import { TranslateLoader, TranslateModule } from "@ngx-translate/core";
import { HttpClient } from "@angular/common/http";
import { ToastrModule } from "ngx-toastr";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
export function createTranslateLoader(http) {
    return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}
var ɵ0 = (createTranslateLoader);
var translateModule = TranslateModule.forRoot({
    loader: {
        provide: TranslateLoader,
        useFactory: ɵ0,
        deps: [HttpClient]
    }
});
var toastrModule = ToastrModule.forRoot({
    autoDismiss: true,
    maxOpened: 1,
    timeOut: 2000,
    positionClass: 'toast-top-center',
    enableHtml: true
});
var CommonAppModule = /** @class */ (function () {
    function CommonAppModule() {
    }
    return CommonAppModule;
}());
export { CommonAppModule };
export { ɵ0 };



// WEBPACK FOOTER //
// ./src/app/common/common-app.module.ts.pre-build-optimizer.js